import { memo } from 'react';
import {
  BaseEdge,
  EdgeLabelRenderer,
  getBezierPath,
  type Edge,
  type EdgeProps,
} from '@xyflow/react';
import { useColorModeValue } from '@components/ui/color-mode';
import type { FunnelEdgeData } from '../types';

type Props = EdgeProps<Edge<FunnelEdgeData>>;

const FunnelEdge = ({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  data,
  label,
  markerEnd,
  style,
  selected,
}: Props) => {
  const curvature = data?.curvature ?? 0.25;
  const labelOffset = data?.labelOffset ?? 0;

  const labelBg = useColorModeValue('#ffffff', '#282827');
  const labelColor = useColorModeValue('#282827', '#ffffff');
  const labelBorder = useColorModeValue('#cccccc', '#4d4d4d');

  const [edgePath, labelX, labelY] = getBezierPath({
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition,
    curvature,
  });

  return (
    <>
      <BaseEdge
        id={id}
        path={edgePath}
        markerEnd={markerEnd}
        style={{
          ...style,
          stroke: selected ? 'var(--chakra-colors-argos-fg)' : undefined,
        }}
      />
      {label && (
        <EdgeLabelRenderer>
          <div
            className="nodrag nopan"
            style={{
              position: 'absolute',
              transform: `translate(-50%, -50%) translate(${labelX}px, ${labelY + labelOffset}px)`,
              background: labelBg,
              color: labelColor,
              border: `1px solid ${labelBorder}`,
              padding: '2px 6px',
              borderRadius: 4,
              fontSize: 11,
              pointerEvents: 'all',
              cursor: 'pointer',
              whiteSpace: 'nowrap',
            }}
          >
            {String(label)}
          </div>
        </EdgeLabelRenderer>
      )}
    </>
  );
};

export default memo(FunnelEdge);
